/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSummariesControllerFindAllQueryResponse, ApplicationSummariesControllerFindAllQueryParams, ApplicationSummariesControllerFindAll401, ApplicationSummariesControllerFindAll403 } from "../../models/checklistsController/ApplicationSummariesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationSummariesControllerFindAll } from "../../clients/checklistsService/applicationSummariesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationSummariesControllerFindAllQueryKey = (params: ApplicationSummariesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-application-summaries'
}, ...(params ? [params] : [])] as const;
export type ApplicationSummariesControllerFindAllQueryKey = ReturnType<typeof applicationSummariesControllerFindAllQueryKey>;
export function applicationSummariesControllerFindAllQueryOptions(params?: ApplicationSummariesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationSummariesControllerFindAllQueryKey(params);
  return queryOptions<ApplicationSummariesControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationSummariesControllerFindAll401 | ApplicationSummariesControllerFindAll403>, ApplicationSummariesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationSummariesControllerFindAll(params, config);
    }
  });
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist application summaries
 * {@link /api/v1/checklist-application-summaries}
 */
export function useApplicationSummariesControllerFindAll<TData = ApplicationSummariesControllerFindAllQueryResponse, TQueryData = ApplicationSummariesControllerFindAllQueryResponse, TQueryKey extends QueryKey = ApplicationSummariesControllerFindAllQueryKey>(params?: ApplicationSummariesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ApplicationSummariesControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationSummariesControllerFindAll401 | ApplicationSummariesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationSummariesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...applicationSummariesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationSummariesControllerFindAll401 | ApplicationSummariesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}